import request from "../../../../../utils/api";

const url = "branches";

export const getSingleBranch = id => request(`${url}/${id}`)
export const postAddBranch = body => request(url, { method: 'post', body });
export const putBranch = body => request(`${url}/${body.get('branch[id]')}`, { method: "put", body })